<template>
  <div class="full-width pl-2" style="word-break: break-word">
    <div v-if="edit">
      <v-row no-gutters>
        <v-col cols="12" sm="12">
          <a-text-field
            :key="locale"
            class="textField"
            ref="name"
            v-if="edit && type === 'text'"
            v-model="text"
            @keyup.enter="
              edit = false;
              $emit('update');
            "
            autofocus
            filled
            dense
            clearable
            required
            @input="onChangeText"
            :disabled="!updateMeetingPermission"
            :label="$t('search.meetingName')"
            :requiredMessage="$t('agenda.ruleMeetingNameReq')"
            @blur="onSaveTextFieldValue"
            :maxLength="maxLength"
          >
          </a-text-field>
        </v-col>
        <v-col
          v-if="false"
          cols="12"
          sm="auto"
          class="text-right d-flex align-center"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-bind="attrs"
                v-on="on"
                class="ml-2"
                x-small
                color="primaryDark"
                width="24"
                min-width="24"
                @click.prevent="onSaveTextFieldValue"
              >
                <v-icon size="16" color="#ffffff"> mdi-check</v-icon>
              </a-btn>
            </template>
            <span>{{ $t("btnSave") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-bind="attrs"
                v-on="on"
                class="ml-2"
                x-small
                color="secondary"
                width="24"
                min-width="24"
                @click.prevent="onBlur"
              >
                <v-icon size="16" color="neutralGray1"> mdi-close</v-icon>
              </a-btn>
            </template>
            <span>{{ $t("btnClose") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </div>
    <div id="header" v-else>
      <span class="text-h5 font-weight-bold ml-2 page-header">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on"> {{ text }} </span>
          </template>
          <span>{{ $t("agenda.lblMeetingTitle") }}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="updateMeetingPermission">
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              class="ml-2"
              x-small
              color="secondary"
              width="24"
              min-width="24"
              v-bind="attrs"
              v-on="on"
              @click="edit = true"
            >
              <v-icon size="16" color="neutralGray1"> mdi-pencil</v-icon>
            </a-btn>
          </template>
          <span>{{ $t("agenda.tipUpdateMeetingTitle") }}</span>
        </v-tooltip>
        <v-btn
          icon
          x-small
          class="mx-3"
          @click="openManual()"
        >
          <v-icon color="#404040">mdi-alert-circle-outline</v-icon>
        </v-btn>
      </span>
    </div>
    <!-- <v-snackbar color="error" v-model="snackbar" :timeout="timeout" top right>
      {{ textReq }}
    </v-snackbar> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { DESCRIPTION_LENGTH_10000 } from "@/utils/constant";
export default {
  name: "InPlaceEditorForMeetingName",
  props: {
    value: {
      type: String,
      default: "",
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "text",
    },
    icon: String,
    lable: "",
  },
  data() {
    return {
      manualClick: 0,
      manualWindow: {},
      testElements: 0,
      edit: false,
      rules: {
        required: (value) => !!value || "Field required.",
      },
      snackbar: false,
      timeout: 2000,
      previousText: "",
      maxLength: DESCRIPTION_LENGTH_10000
    };
  },
  watch: {
    edit(value) {
      if (value) {
        this.testElements = 0;
        this.$emit("contentPadding", this.testElements);
      }
    },
    text(value) {
      if (value) {
        this.getHeaderHeight();
      }
    },
  },
  computed: {
    ...mapGetters({
      getMeetingTypeId: "meeting/getMeetingTypeId",
    }),
    locale() {
      return this.$i18n.locale;
    },
    text: {
      get() {
        this.previousText = this.previousText || this.value.trim();
        return this.value;
      },
      set(value) {
        this.$emit("input", value || "");
      },
    },
    updateMeetingPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "UpdateMeeting"
        );
      }
      return false;
    },
  },
  mounted() {
    this.getHeaderHeight();
  },
  methods: {
    openManual() {
      this.manualClick += 1;
      let height = screen.height;
      let width = screen.width;
      let strWindowFeatures =
        "location=no,toolbar=no,menubar=no,height=" +
        height +
        ",width=" +
        width +
        ",scrollbars=auto,fullscreen=yes";
      let routeData = this.$router.resolve({
        path: '/usermanual',
        query: { content: this.$i18n.locale == "en" ? "Manual_E_Meeting.pdf" : "Manual_Meeting.pdf", id: this.$route.name },
      });
      let popup;
      if (routeData && (typeof this.manualWindow === "undefined" ||
        this.manualWindow.closed || this.manualClick === 1)) {
        popup = window.open(routeData.href, "_blank", strWindowFeatures);
        this.manualWindow = popup;
        popup.moveTo(0, 0);
      }
      else {
        this.manualWindow.focus();
      }
    },
    getHeaderHeight() {
      setTimeout(() => {
        const element = document.getElementById("header");
        if (element) {
          this.testElements = element.offsetHeight;
          this.$emit("contentPadding", this.testElements);
        }
      }, 100);
    },
    onSaveTextFieldValue() {
      if (this.text.trim()) {
        this.edit = false;
      } else {
        this.snackbar = true;
      }

      setTimeout(() => {
        if (document.getElementById("header")) {
          this.testElements = document.getElementById("header").offsetHeight;
          this.$emit("contentPadding", this.testElements);
        }
      }, 100);
    },
    onBlur() {
      this.text = this.previousText;
      this.edit = false;
      setTimeout(() => {
        this.testElements = document.getElementById("header").offsetHeight;
        this.$emit("contentPadding", this.testElements);
      }, 100);
    },
    onChangeText(value) {
      this.$eventHub.$emit("onMeetingUpdate");
    },
  },
};
</script>

<style scoped>
.v-text-field.v-text-field--enclosed /deep/ .v-text-field__details {
  margin-bottom: 0px !important;
}
.textField /deep/ .v-label {
  line-height: 18px !important;
}
.v-text-field input {
  line-height: 0px !important;
}
</style>